import { render, staticRenderFns } from "./z_auxiliary_box.vue?vue&type=template&id=78f838b1&scoped=true"
import script from "./z_auxiliary_box.vue?vue&type=script&lang=js"
export * from "./z_auxiliary_box.vue?vue&type=script&lang=js"
import style0 from "./z_auxiliary_box.vue?vue&type=style&index=0&id=78f838b1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f838b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f838b1')) {
      api.createRecord('78f838b1', component.options)
    } else {
      api.reload('78f838b1', component.options)
    }
    module.hot.accept("./z_auxiliary_box.vue?vue&type=template&id=78f838b1&scoped=true", function () {
      api.rerender('78f838b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/z_auxiliary_box.vue"
export default component.exports